
class HeaderNotificationController {
    constructor($window, shopperService, analyticsService, orderManagementService, settings) {
        this.$window = $window;
        this.shopperService = shopperService;
        this.analyticsService = analyticsService;
        this.orderManagementService = orderManagementService;
        this.settings = settings;

        this.orderId = 0;
        this.shouldShowNotification = false;
        this.isCancelDisabled = false;
    }

    $onInit() {
        this.setNotificationTitle();
        if (!this.shopperService.IsGuest) {
            this.getOrderBeingAmended();
        }
    }

    cancelChanges() {
        if (!this.isCancelDisabled) {
            this.isCancelDisabled = true;
            this.orderManagementService.changeOrder(this.orderId, true).then(() => {
                this.shouldShowNotification = false;
                this.$window.location.href = `/shop/myaccount/myorders/${this.orderId}?amendReverted=1`;
            }).finally(() => {
                this.isCancelDisabled = false;
            });
        }
    }

    getOrderBeingAmended() {
        this.orderManagementService.getOrderBeingAmended().then((response) => {
            if (!response.OrderId) {
                this.shouldShowNotification = false;
            } else {
                this.shouldShowNotification = true;
                this.orderId = response.OrderId;
                this.setNotificationMessage(new Date(response.AmendCutoffTime));
            }
        });
    }

    setNotificationTitle() {
        this.notificationTitle = this.settings.orderManagement.notificationBannerTitle;
    }

    setNotificationMessage(cutOffDateTime) {
        const formattedCutOffTime = this.getFormattedCutOffTime(cutOffDateTime);
        const message = this.settings.orderManagement.notificationBannerMessage;
        this.notificationMessage = message.replace('{0}', formattedCutOffTime);
    }


    getFormattedCutOffTime(cutOffDateTime) {
        const hour = cutOffDateTime.toLocaleString(undefined, this.getHourOptions(cutOffDateTime));
        const weekday = cutOffDateTime.toLocaleString(undefined, { weekday: 'long' });
        const date = cutOffDateTime.getDate();
        const month = cutOffDateTime.toLocaleString(undefined, { month: 'long' });

        return `${hour}, ${weekday} ${date} ${month}`;
    }

    getHourOptions(date) {
        if (date.getMinutes() > 0) {
            return { hour: 'numeric', minute: 'numeric', hour12: true };
        }
        return { hour: 'numeric', hour12: true };

    }
}

const headerNotificationComponentDefinition = {
    controller: [
        '$window',
        'ShopperService',
        'AnalyticsService',
        'OrderManagementService',
        'Settings',
        HeaderNotificationController,
    ],
    template: require('./header-notification.component.html').trim(),
};

module.exports = {
    HeaderNotificationController,
    headerNotificationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/header-notification/header-notification.component.js